import moment from 'moment';

export const getPolishMonthName = (monthIndex) => {
    const months = [
        'stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca',
        'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia'
    ];
    return months[monthIndex];
};

export const calculateDateRange = (rangeKey) => {
    const today = moment().startOf('day');
    let startDate, endDate;

    switch (rangeKey) {
        case 'today':
            startDate = today.clone();
            endDate = today.clone();
            break;
        case 'tomorrow':
            startDate = today.clone().add(1, 'days');
            endDate = today.clone().add(1, 'days');
            break;
        case 'this_weekend':
            startDate = today.clone().isoWeekday(5); // Friday
            if (startDate.isBefore(today)) {
                startDate.add(1, 'week');
            }
            endDate = startDate.clone().isoWeekday(7); // Sunday
            break;
        case 'next_week':
            startDate = today.clone().add(1, 'week').startOf('isoWeek');
            endDate = today.clone().add(1, 'week').endOf('isoWeek');
            break;
        case 'this_month':
            startDate = today.clone();
            endDate = today.clone().add(30, 'days');
            break;
        default:
            return null;
    }

    return {
        startDate: startDate.toDate(),
        endDate: endDate.toDate()
    };
};
